module.exports = __webpack_public_path__ + "static/media/tp_sea_anemone.30628199.jpg";